import React, { useContext, useEffect, useState, useCallback } from "react";
import {Form,Input, Button, Row, Col, Modal, notification,
  InputNumber, List, Popconfirm, Upload, Select} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
import { DeleteOutlined, UploadOutlined} from "@ant-design/icons";
import LoadingModal from "../../utils/LoadingModal";


const { TextArea } = Input;
const { Option } = Select;

const MeetingPointsForm = ({
  open,
  isEdit,
  currentMeetingPoint,
  onFinish,
  onCancel,
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAttachments = useCallback(async () => {
    try {
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/consult-attach-files/${currentMeetingPoint.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      console.log("response", response.data.data);
      setFileList(response?.data?.data.rows);
    } catch (error) {
      console.error("Error fetching attachments:", error.response);
      if (error?.response?.data.status !== -2) {
        notification.error({
          message: "Error obteniendo archivos adjuntos",
          placement: "bottomRight",
        });
      }
      setFileList([]);
    }
  }, [globals, currentMeetingPoint]);

  const fetchClassifications = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/classifications`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setClassifications(response?.data?.data);
    } catch (error) {
      console.error("Error fetching classifications:", error.response);
      notification.error({
        message: "Error obteniendo clasificaciones",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  useEffect(() => {
    if (isEdit) {
      console.log("currentMeetingPoint", currentMeetingPoint);
      fetchAttachments();
      fetchClassifications();
      form.setFieldsValue({
        name: currentMeetingPoint.name,
        description: currentMeetingPoint.description,
        meeting_type_name: currentMeetingPoint.meeting_type_name,
        department_name: currentMeetingPoint.department_name,
        point_type_name: currentMeetingPoint.point_type_name,
        classificationId: currentMeetingPoint.classificationId,
        duration: currentMeetingPoint.duration,
        responsible: currentMeetingPoint.responsible,
      });
    }
    else{
      form.setFieldsValue({
        duration: 15,
      });
    }
  }, [isEdit, currentMeetingPoint, form, open, fetchAttachments, fetchClassifications]);

  const handleAddFile = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('meetingPointDetailsId', currentMeetingPoint.id);

    setLoading(true);
    try {
      // Aquí realizas tu propia lógica de carga
      const response = await axios.post(`${globals.SERVICE_API_DB}/v1/create-attach-file`
        , formData, {
        headers: {
          "x-token": globals.token,
          "Content-Type": "multipart/form-data",
        },
      });

      onSuccess(response, file);
      console.log("response", response.data);
      setFileList([...fileList, response.data.data[0]]);
      notification.success({
        message: `${file.name} cargado correctamente.`,
        placement: "bottomRight",
      });
    } catch (error) {
      onError(error);
      notification.error({
        message: `Error al cargar ${file.name}.`,
        placement: "bottomRight",
      });
    } finally {
      setLoading(false);
    }



  };

  const handleFileDelete = async (file) => {

    try {
      const response = await axios.delete(`${globals.SERVICE_API_DB}/v1/delete-attach-file/${file.id}`, {
        headers: {
          "x-token": globals.token,
        },
      });
      console.log("response", response);  
      if (response.data.status === 0) {
        notification.success({
          message: `${file.name} eliminado correctamente.`,
          placement: "bottomRight",
        });
        
        setFileList(fileList.filter((f) => f.id !== file.id));
      }
      else{
        notification.error({
          message: `Error al eliminar ${file.name}.`,
          placement: "bottomRight",
        });
      }
    }
    catch (error) {
      console.error("Error deleting file:", error.response);
      notification.error({
        message: "Error eliminando archivo",
        placement: "bottomRight",
      });
    }
    
    
  };

  const handleComplete = async (values) => {
    try {
      if (isEdit) {
        values.id = currentMeetingPoint.id;
        console.log("values", values);
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-meeting-point-detail/${currentMeetingPoint.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        console.log("response", response.data)
        if (response?.data?.status === 0) {
          currentMeetingPoint = mergeProps(
            currentMeetingPoint,
            response?.data?.data
          );
          onFinish({ status: "edited" });
        }
        form.resetFields();
        return;
      }
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-meeting-point-details/${currentMeetingPoint.meetingId}`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      onFinish({ status: "created", newMeetingPoint: response?.data?.data });
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error.response);
      notification.error({
        message: "Error guardando punto de plantilla",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={isEdit ? "Editar Punto estándar" : "Crear Punto estándar"}
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      <LoadingModal open={loading} />
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="meeting_type_name"
              label="Tipo de reunión"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
              <Input disabled={isEdit}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="department_name"
              label="Departamento"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
               <Input disabled={isEdit} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="point_type_name"
              label="Tipo de punto"
              rules={[{ required: true, message: "No se permite dejar en blanco" }]}
            >
              <Input disabled={isEdit}/>
            </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
              name="classificationId"
              label="Clasificación"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select placeholder="Selecciona una opción">
                {classifications.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="name"
          label="Nombre del punto"
          rules={[{ required: true, message: "Este campo es requerido" }]}
        >
          <Input disabled={isEdit}/>
        </Form.Item>
        <Row gutter={16}>
          <Col span={5}>
              <Form.Item label="Duración" name="duration" tooltip="minutos">
                <InputNumber
                  min={1}
                />
              </Form.Item>
          </Col>
          <Col span={19}>
            <Form.Item
            name="responsible"
            label="Responsable"
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
              { required: true, message: "Por favor ingrese el responsable" },
            ]}
            >
              <Input/>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Descripción" name="description">
          <TextArea rows={4} disabled={isEdit}/>
        </Form.Item>
        
        <Row gutter={16}>
          <Col span={12}>
            <Upload
              showUploadList={false}
              customRequest={handleAddFile}
              fileList={uploadFileList}
              onChange={(info) => {
                setUploadFileList(info.fileList);
              }}
            >
              <Button icon={<UploadOutlined />}>Cargar adjuntos</Button>
            </Upload>
          </Col>
        </Row>
        <Form.Item label="Archivos adjuntos">
          <List
            dataSource={fileList}
            renderItem={file => (
              <List.Item
                actions={[
                  <Popconfirm
                    title="¿Está seguro que desea eliminar este archivo?"
                    onConfirm={() => handleFileDelete(file)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Button icon={<DeleteOutlined />} danger>Eliminar</Button>
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta
                  title={<a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.name}
                </a>}
                />
              </List.Item>
            )}
          />
        </Form.Item>
        <Row justify="end">
          <Col>
            <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
              {isEdit ? "Actualizar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MeetingPointsForm;
